import { useMemo } from "react";
import { useSyncedResource } from "hooks/useSyncedResource.hook";
import * as SCOPE from "services/sync/scope";
import useInfrastructure from "hooks/useInfrastructure.hook";
import * as agentsSync from "services/sync/resources/chat/agents.sync";

export function useChatAgents({ enabled = true, lineId } = {}) {
  const { syncEngine, repositories } = useInfrastructure();
  const repository = repositories.agents

  enabled = enabled && !!lineId;
  const scope = SCOPE.CHAT.AGENTS;
  const key = useMemo(() => `(lineId:${lineId})`, [lineId]);
  const syncParams = useMemo(() => ({}), []);

  return useSyncedResource({
    enabled,
    scope,
    key,
    cacheFn: ({ scope, key }) => repository.getFromCache(scope, key, () => repository.getByLineId(lineId, repositories)),
    syncParams,
    syncFn: agentsSync.all,
    syncEngine,
    repository,
    repositories,
    deps: [lineId]
  });
}